(function($) {

	'use strict';

	function init() {
        initListeners();
	};

    function initListeners() {
        window.onscroll = function()
        {
            if (pageYOffset >= (window.innerHeight / 2)) {
                $('.backToTop').addClass('visible');
            } else {
                $('.backToTop').removeClass('visible');
            }
        };
    }

	$(document).ready(function() {
        if ($('.backToTop')[0]) {
            init();
        }
	});

})(jQuery);
